// A leaping fish, modelled facing +X: a silvery streamlined body with a forked
// tail and a small dorsal fin. Ported 1:1 from age-of-mcp's classic
// leaping-fish.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#9fb6c4",
      position: [0, 0.026, 0], scale: [2.1, 0.85, 0.6] },           // body
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#c2d2dc",
      position: [0.018, 0.02, 0], scale: [1.6, 0.8, 0.6] },          // pale belly
    { geometry: new THREE.ConeGeometry(0.024, 0.04, 3), color: "#7e96a6",
      position: [-0.055, 0.026, 0], rotation: [0, 0, Math.PI / 2], scale: [1, 1, 0.3] }, // tail
    { geometry: new THREE.ConeGeometry(0.012, 0.026, 3), color: "#7e96a6",
      position: [0.0, 0.05, 0], scale: [1, 1, 0.3] },               // dorsal fin
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#101418",
      position: [0.05, 0.03, 0.01] },                               // eye
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#101418",
      position: [0.05, 0.03, -0.01] },
  ];
}

export const leapingFish = defineModel({
  id: "leaping-fish",
  batchId: "standard",
  name: "Leaping fish",
  tags: ["creature","leaping","fish","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly leaping fish.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => partsFor(),
  animations: [],
});
